var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('h2',[_vm._v("Is this ok?")])])],1),_c('v-row',[_c('v-col',[_c('ValidationObserver',{ref:"observer"},[_c('CardCandidateReview',{attrs:{"candidate":_vm.candidate}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }